import Box from '@zenbusiness/zui/Box';
import superstyled from '@zenbusiness/zui/styles/superstyled';

// Shared layout components (aligned with MarketAnalysisReport pattern)
export const ReportRoot = superstyled({
  name: 'SloganGeneratorResults',
  slot: 'Root',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    padding: theme.spacing(3),
    backgroundColor: theme.palette.background.grey.light,
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.border.main}`
  })
});

export const ReportContent = superstyled({
  name: 'SloganGeneratorResults',
  slot: 'Content',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(3),
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      gap: theme.spacing(2)
    }
  })
});

// Action buttons container for SidePanel
export const ButtonGroup = superstyled({
  name: 'SloganGeneratorResults',
  slot: 'ButtonGroup',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2)
  })
});
